import { $$ } from './helper'

export class Tracking {
  constructor (settings = {}) {
    this.options = $.extend({
      googleAnalyticsId: 'UA-39332172-1',
      googleAdsId: 'AW-806733915',
      googleTagManager: 'GTM-P9C5JHZ',
      allowedDomains: [
        'www.bkkgs.de',
        'www-dev.bkkgs.de'
      ]
    },
    settings)
  }

  init () {
    const that = this

    this.options.allowedDomains.forEach(function (domain) {
      if (domain === window.location.hostname && !window.location.pathname.startsWith('/styleguide')) {
        if ((window.name === 'newTYPO3frontendWindow') || (Cookiebot.consent !== undefined && Cookiebot.consent.statistics)) {
          that.addGoogleTagManager()
        }

        // matomo runs cookieless and is therefore loaded independently of the cookie consent
        that.addMatomoTagManager()
        that.addMatomo()
      }
    })

    this.initCampaignPopupTracking()
  }

  initCampaignPopupTracking () {
    const variants = ['modal3', 'modal4']
    const actions = ['impression', 'close', 'cta-click']

    variants.forEach((variant) => {
      actions.forEach((action) => {
        document.addEventListener(`${variant}:${action}`, (event) => {
          const detail = (event && event.detail) || {}
          this.pushCampaignPopupEvent({
            variant,
            action,
            source: detail.source || ''
          })
        })
      })
    })
  }

  pushCampaignPopupEvent ({ variant, action, source }) {
    const statisticsAllowed = !!(window.Cookiebot && window.Cookiebot.consent && window.Cookiebot.consent.statistics)

    if (window.dataLayer && (window.name === 'newTYPO3frontendWindow' || statisticsAllowed)) {
      window.dataLayer.push({
        event: 'campaign_popup',
        popup_variant: variant,
        popup_action: action,
        popup_source: source
      })
    }

    if (window._paq) {
      window._paq.push(['trackEvent', 'Campaign Popup', `${variant} - ${action}`, source || variant])
    }
  }

  addGoogleTagManager () {
    const that = this
    if (!document.getElementById('googleTagManager')) {
      window.dataLayer = window.dataLayer || []
      window.gtag = function () { window.dataLayer.push(arguments) }

      window.gtag('consent', 'default', {
        ad_storage: 'denied',
        analytics_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        wait_for_update: 500
      })

      window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' })

      const script = document.createElement('script')
      script.src = 'https://www.googletagmanager.com/gtm.js?id=' + this.options.googleTagManager
      script.type = 'text/javascript'
      script.id = 'googleTagManager'
      script.setAttribute('data-cookieconsent', 'Statistics')
      script.async = true
      document.head.appendChild(script)

      window.addEventListener('CookiebotOnAccept', that.updateConsentFromCookiebot)
      window.addEventListener('CookiebotOnDecline', that.updateConsentFromCookiebot)
      window.addEventListener('CookiebotOnLoad', that.updateConsentFromCookiebot)
      window.addEventListener('CookiebotLoaded', that.updateConsentFromCookiebot)
    }
  }

  updateConsentFromCookiebot () {
    const analyticsGranted = !!(window.Cookiebot && Cookiebot.consent && Cookiebot.consent.statistics)

    window.gtag && window.gtag('consent', 'update', {
      analytics_storage: analyticsGranted ? 'granted' : 'denied'
    })
  }

  addMatomo () {
    const matomo = $$('#matomo')
    if (matomo.length === 0) {
      const _paq = window._paq = window._paq || []
      _paq.push(['trackPageView'])
      _paq.push(['enableLinkTracking'])

      const u = '//www.bkkgs.de/matomo/'

      _paq.push(['setTrackerUrl', u + 'matomo.php'])
      _paq.push(['setSiteId', '1'])

      const d = document
      const g = d.createElement('script')
      const s = d.getElementsByTagName('script')[0]
      g.async = true
      g.src = u + 'matomo.js'
      g.id = 'matomo'
      s.parentNode.insertBefore(g, s)
    }
  }

  addMatomoTagManager () {
    const matomotag = $$('#matomotag')
    if (matomotag.length === 0) {
      const _mtm = window._mtm = window._mtm || []
      const d = document
      const g = d.createElement('script')
      const s = d.getElementsByTagName('script')[0]

      _mtm.push({
        'mtm.startTime': (new Date().getTime()),
        event: 'mtm.Start'
      })

      g.async = true
      g.src = 'https://www.bkkgs.de/matomo/js/container_3EBPR2dT.js'
      g.id = 'matomotag'
      s.parentNode.insertBefore(g, s)
    }
  }

  gtag () {
    window.dataLayer.push(arguments)
  }
}

export default Tracking
